import { Model } from '@vuex-orm/core'
import Contact from './Contact'
import Slab from './Slab'

export default class Project extends Model {
  static entity = 'projects'

  static fields () {
    return {
      id: this.string(''),
      name: this.string('Project 1'),
      code: this.string(''),
      description: this.string(''),
      opco_id: this.number(1),
      norm_id: this.number(1),
      date_add: this.string(''),
      date_last_save: this.string(''),
      contacts: this.hasMany(Contact, 'project_id'),
      slabs: this.hasMany(Slab, 'project_id'),
      // extra: needed for other purposes
      savedOnServer: this.boolean(false)
    }
  }

  get displayAs () {
    return (this.code ? `(${this.code}) ` : '') + this.name
  }

  // prepare for server POST
  get prepareSend () {
    // clone project
    let data = {...this}

    // remove empty contacts
    data.contacts = data.contacts.filter(contact => !contact.isBlank)

    return data
  }

  // check if any of it's elements is locked or not
  isLocked () {
    return !!Slab.getters('query')().where((slab, _query, model) => slab.project_id === this.id && model.isLocked()).first()
  }

  // unlock all locked elements
  unlock () {
    Slab.getters('query')()
      .where((slab, _query, model) => slab.project_id === this.id && model.isLocked()).get()
      .forEach(slab => Slab.store().commit('db/slabs/unlock', slab.id))
  }
}



// WEBPACK FOOTER //
// ./src/store/models/Project.js